export const SnapshotResponseDelay = 10000
